"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateKDMMeetingDto = exports.CreateKDMMeetingDto = exports.RemarksMomSection = exports.KDMMeetingFormFieldsDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const create_meeting_dto_1 = require("../../meeting/dto/create-meeting.dto");
class KDMMeetingFormFieldsDto {
}
exports.KDMMeetingFormFieldsDto = KDMMeetingFormFieldsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "KDM Meeting Type ID",
        example: 343,
    }),
    (0, class_validator_1.IsInt)({ message: "KDM Meeting type must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "KDM Meeting type is required." }),
    (0, class_validator_1.Min)(1, {
        message: "KDM Meeting type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], KDMMeetingFormFieldsDto.prototype, "kdmMeetingTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Selected Meeting ID",
        example: 123,
    }),
    (0, class_validator_1.IsInt)({ message: "Selected Meeting id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Selected Meeting id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], KDMMeetingFormFieldsDto.prototype, "selectMeeting", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting Date",
        example: "2025-12-10",
    }),
    (0, class_validator_1.IsDate)({ message: "Meeting Date must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date) // Transform string to Date
    ,
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting Date is required." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to midnight
        if (value < today) {
            throw new common_1.BadRequestException("The meeting date cannot be a past date. Please provide a valid date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], KDMMeetingFormFieldsDto.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Start Time (time with time zone, ISO 8601 format)",
        type: String,
        example: "10:00:00+05:30",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Start time is required." }),
    (0, class_validator_1.IsString)({
        message: "Start Time must be a string in time with time zone format (e.g., 10:00:00+05:30).",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        // Validate ISO 8601 time with time zone (e.g., 10:00:00+05:30)
        const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-][0-1]\d:[0-5]\d|Z)$/;
        if (!regex.test(value)) {
            throw new common_1.BadRequestException("Start Time must be in 'HH:mm:ss±HH:mm' or 'HH:mm:ssZ' format.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], KDMMeetingFormFieldsDto.prototype, "availableFrom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "End Time (time with time zone, ISO 8601 format)",
        type: String,
        example: "11:00:00+05:30",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "End time is required." }),
    (0, class_validator_1.IsString)({
        message: "End Time must be a string in time with time zone format (e.g., 11:00:00+05:30).",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        // Validate ISO 8601 time with time zone (e.g., 11:00:00+05:30)
        const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-][0-1]\d:[0-5]\d|Z)$/;
        if (!regex.test(value)) {
            throw new common_1.BadRequestException("End Time must be in 'HH:mm:ss±HH:mm' or 'HH:mm:ssZ' format.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], KDMMeetingFormFieldsDto.prototype, "availableTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting Type ID",
        example: 343,
    }),
    (0, class_validator_1.IsInt)({ message: "Meeting type must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting type is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Meeting type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], KDMMeetingFormFieldsDto.prototype, "meetingTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "KDM Meeting location",
        example: 300,
    }),
    (0, class_validator_1.IsInt)({ message: "Location type must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Location type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], KDMMeetingFormFieldsDto.prototype, "locationTypeLid", void 0);
class RemarksMomSection {
}
exports.RemarksMomSection = RemarksMomSection;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Meeting minutes",
        example: "KDM Meeting minutes",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], RemarksMomSection.prototype, "mom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "KDM Meeting remarks",
        example: "Remarks about the KDM Meeting",
    }),
    (0, class_validator_1.IsString)({ message: "KDM Meeting remarks must be a string." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], RemarksMomSection.prototype, "remarks", void 0);
class CreateKDMMeetingDto {
}
exports.CreateKDMMeetingDto = CreateKDMMeetingDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Activity ID",
        example: 123,
    }),
    (0, class_validator_1.IsInt)({ message: "Activity id must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Activity id is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Activity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateKDMMeetingDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "KDM Meeting status ID",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Status ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Status ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Status ID must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateKDMMeetingDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "KDM Meeting form fields",
        type: KDMMeetingFormFieldsDto,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "KDM Meeting form fields are required." }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => KDMMeetingFormFieldsDto),
    tslib_1.__metadata("design:type", KDMMeetingFormFieldsDto)
], CreateKDMMeetingDto.prototype, "kdmMeetingFormFields", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Remarks and Minutes of Meeting section",
        type: RemarksMomSection,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksMomSection),
    tslib_1.__metadata("design:type", RemarksMomSection)
], CreateKDMMeetingDto.prototype, "remarksMomSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Kdm meeting Participants",
        type: create_meeting_dto_1.ParticipantsDto,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "KDM Meeting participants are required." }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_meeting_dto_1.ParticipantsDto),
    tslib_1.__metadata("design:type", typeof (_b = typeof create_meeting_dto_1.ParticipantsDto !== "undefined" && create_meeting_dto_1.ParticipantsDto) === "function" ? _b : Object)
], CreateKDMMeetingDto.prototype, "participants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "KDM Meeting documents",
        type: [create_meeting_dto_1.CreateMeetingDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "KDM Meeting documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_meeting_dto_1.CreateMeetingDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateKDMMeetingDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateKDMMeetingDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateKDMMeetingDto.prototype, "updatedBy", void 0);
class UpdateKDMMeetingDto extends (0, swagger_1.PartialType)(CreateKDMMeetingDto) {
}
exports.UpdateKDMMeetingDto = UpdateKDMMeetingDto;
